function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.4756C12.2554 16.4756 15.7563 12.9746 15.7563 8.71924C15.7563 4.45654 12.2554 0.955566 7.99268 0.955566C3.72998 0.955566 0.236328 4.45654 0.236328 8.71924C0.236328 12.9746 3.7373 16.4756 8 16.4756ZM7.18701 12.4033C6.85742 12.4033 6.58643 12.2495 6.35938 11.9639L4.64551 9.92773C4.46973 9.72266 4.40381 9.53223 4.40381 9.3125C4.40381 8.85107 4.77734 8.48486 5.23877 8.48486C5.50244 8.48486 5.70752 8.59473 5.90527 8.8291L7.17236 10.3672L10.0068 5.87012C10.2046 5.55518 10.4463 5.39404 10.7393 5.39404C11.1934 5.39404 11.6035 5.73096 11.6035 6.19238C11.6035 6.37549 11.5303 6.58057 11.3984 6.771L7.99268 11.9492C7.80225 12.2349 7.50928 12.4033 7.18701 12.4033Z",
  fill: "#a7a7a7"
});

var SvgTickFullShadow = function SvgTickFullShadow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTickFullShadow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick_full_shadow.16b227de.svg";
export { ForwardRef as ReactComponent };